module.exports = __webpack_public_path__ + "static/img/sy-5.9f0c91a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/introduce/sy-5.png
// module id = XGg5
// module chunks = 63